import { MfBladeFormsComponent, IBladeForm } from "@framework/components/mf-blade-forms/mf-blade-forms.component";
import * as blades from "@framework/components/mf-blade/MfBladeExt";
import { TutorialComponent } from "../../../modules/requisition/components/tutorial/tutorial.component";

export class JCEWorkOrdersBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    { displayName: "Search", component: blades.WorkOrderSearchBlade, index: 0, width: 800, hideClose: true, autoMinimise: false, minimiseWhenLowerThanIndex: 1 },
    { displayName: "Work Order", component: blades.WorkOrderBlade, index: 1, width: 600 },
    { displayName: "Job Card", component: blades.JobCardBlade, index: 2, width: 600 },
    { displayName: "Invoice", component: blades.InvoiceBlade, index: 3, width: 600 },
  ];
}

export class JCEInvoicesBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    { displayName: "Invoice", component: blades.InvoiceListBlade, index: 0, width: 600 },
  ];
}

export class JCEScaffoldingBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    
  ];
}

export class JCEReportBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [

  ];
}

export class UsersBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    { displayName: "Search", component: blades.UserSearchBlade, index: 0, width: 800, hideClose: true  },
    { displayName: "User", component: blades.UserDetailBlade, index: 1, width: 800 },
    { displayName: "Contact Details", component: blades.PartyContactSpecificBlade, index: 2, width: 400, showOnlyIfIdInUrl:true },
    { displayName: "Addresses", component: blades.PartyAddressBlade, index: 3, width: 400, showOnlyIfIdInUrl: true },
  ];
}



export class OrganisationBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    { displayName: "Search", component: blades.OrgSearchBlade, index: 0, width: 800, hideClose: true },
    { displayName: "Role", component: blades.OrganisationDetailsBlade, index: 1, width: 800 },
  ];
}

export class GlobalRoleBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    { displayName: "Search", component: blades.GlobalRoleSearchBlade, index: 0, width: 800, hideClose: true },
    { displayName: "Role", component: blades.GlobalRoleDetailsBlade, index: 1, width: 800 },
  ];
}

export class RequisitionBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    { displayName: "Search", component: blades.RequisitionListBlade, index: 0, width: 1024, hideClose: true },
    { displayName: "Requisition", component: blades.RequisitionBlade, index: 1 },
    { displayName: "Requisition Item", component: blades.RequisitionItemBlade, index: 2, showOnlyIfIdInUrl: true },
    { displayName: "Requisition Workflows", component: blades.RequisitionWorkflowBlade, index: 3, width: 800, showOnlyIfIdInUrl: true },
    { displayName: "Requisition Document", component: blades.RequisitionFileCabinetBlade, index: 4, width: 800, showOnlyIfIdInUrl: true },
    { displayName: "Requisition Item Workflows", component: blades.RequisitionItemWorkflowBlade, index: 5, width: 800, showOnlyIfIdInUrl: true },
    { displayName: "Requisition Groups", component: blades.RequisitionPartialBlade, index:6, showOnlyIfIdInUrl: true },
    { displayName: "Requisition Item", component: blades.RequisitionItemProcessedBlade, index: 7,  showOnlyIfIdInUrl: true },
    { displayName: "Requisition Item Workflows", component: blades.RequisitionItemWorkflowBlade, index: 8, width: 800, showOnlyIfIdInUrl: true },
  ];
}

export class SuppliersBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    { displayName: "Search", component: blades.SupplierSearchBlade, index: 0, width: 800, hideClose: true, autoMinimise: true },
    { displayName: "Supplier", component: blades.SupplierDetailBlade, index: 1, width: 800, autoMinimise: true },
    { displayName: "Supplier Document", component: blades.SupplierFileCabinetBlade, index: 2, width: 800, autoMinimise: true, showOnlyIfIdInUrl: true },
    { displayName: "Supplier Contact", component: blades.SupplierPartyContactBlade, index: 3, width: 800, autoMinimise: true, showOnlyIfIdInUrl: true },
  ];
}

export class InvoiceBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    { displayName: "Search", component: blades.CustomInvoiceListBlade, index: 0, width: 800, hideClose: true },
    { displayName: "Invoice Details", component: blades.CustomInvoiceBlade, index: 1, width: 800, autoMinimise: false },
  ];
}

export class SiteBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    { displayName: "Search", component: blades.SiteSearchBlade, index: 0, width: 800, hideClose: true, autoMinimise: false, minimiseWhenLowerThanIndex: 1 },
    { displayName: "Site Details", component: blades.SiteDetailBlade, index: 1, width: 800, autoMinimise: true },
    { displayName: "Job Number Details", component: blades.ProjectJobNumberBlade, index: 2, width: 800, autoMinimise: true },
  ];
}

export class StockItemBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    { displayName: "Catalog Items", component: blades.StockSearchBlade , index: 0, width: 800, hideClose: true, autoMinimise: false, minimiseWhenLowerThanIndex: 1 },
    { displayName: "Stock item Details", component: blades.StockItemBlade, index: 1, width: 800, autoMinimise: true, showOnlyIfIdInUrl: true  },
    { displayName: "Stock item Supplier Details", component: blades.StockItemSupplierBlade, index: 2, width: 800, autoMinimise: true, showOnlyIfIdInUrl: true  },
    { displayName: "Stock item attachment", component: blades.StockItemFileCabinetBlade, index: 3, width: 800, autoMinimise: true, showOnlyIfIdInUrl: true  }, 
    
  ];
}

export class RequisitionItemReportBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    { displayName: "Search", component: blades.RequisitionReportSelectBlade, index: 0,  hideClose: true },
    { displayName: "Req Items", component: blades.RequisitionItemReportListBlade, index: 1,  showOnlyIfIdInUrl: true },
    { displayName: "Req Actions Required", component: blades.RequisitionReportActionsRequiredListBlade, index: 2, showOnlyIfIdInUrl: true },
	  { displayName: "Oustanding Items", component: blades.RequisitionItemReportOutstandingItemsListBlade, index: 3, showOnlyIfIdInUrl: true },
	  { displayName: "Detailed Items", component: blades.RequisitionItemDetailedReportListBlade, index: 4, showOnlyIfIdInUrl: true },
  ];
}

export class RequisitionTutorialBlades extends MfBladeFormsComponent {
  protected forms: Array<IBladeForm> = [
    {
      displayName: "How it works", component: blades.RequisitionTutorialBlade, index: 0,
      hideClose: true
    },
  ];
}

export class DetailedWIPReportBlades extends MfBladeFormsComponent {
	protected forms: Array<IBladeForm> = [
		{
			displayName: "Detailed WIP Report", component: blades.DetailedWIPReportBlade, index: 0,
			hideClose: true
		},
	]
}
